import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { ContactInfoItems } from '@redlink/components/molecules';

export const PreviewResumeContactInfo = memo(({ title, data = {} }) => {
  const { styles, colors } = useStyle();
  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <Space size={8} />
      <View style={styles.contentContainer}>
        <ContactInfoItems {...{ data }} iconColor={colors.subtitle} />
      </View>
    </View>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  container: {},
  contentContainer: {
    padding: 16,
    borderRadius: 10,
    backgroundColor: colors.cardBackground,
  },
  title: {
    fontSize: 16,
    color: colors.title,
    fontWeight: 'bold',
  },
}));
